define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../../store", "../services", "../services/EventManager"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, store_1, services_1, EventManager_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WaDoc = void 0;
    class WaDoc extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "WaId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "WaIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocName", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocNameError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocDesc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "DocDescError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovalStatus", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ApprovalStatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsUpload", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "IsUploadError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Wa", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, WaDoc.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Wa = parent;
            this.WaId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
        }
        onRead(entity, parent) {
            this.Wa = parent;
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.WaId = (0, EntityUtil_1.toInt)(entity.WaId);
            a.DocType = (0, EntityUtil_1.toInt)(entity.DocType);
            a.DocName = b.DocName;
            a.DocDesc = b.DocDesc;
            a.ApprovalStatus = b.ApprovalStatus;
            a.IsUpload = (0, EntityUtil_1.toInt)(entity.IsUpload);
            a.CreateUser = b.CreateUser;
            a.CreateDate = b.CreateDate;
            a.AuditEditUser = b.AuditEditUser;
            a.AuditEditDate = b.AuditEditDate;
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, WaDoc.AliasName);
            this.reset();
            this._validate(validationState, recurseChildren);
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                this.validateReqNumber(validationState, "WaId", "Water Agreement ID");
                this.validateReqNumber(validationState, "DocType", "Document Type");
                this.validateReqString(validationState, "ApprovalStatus", "Approval Status ");
                this.validateReqNumber(validationState, "IsUpload", "Is Uploaded?");
                this.validateReqString(validationState, "CreateUser", "Create User");
                this.validateReqDate(validationState, "CreateDate", "Create Date");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                WaId: this.WaId,
                DocType: this.DocType,
                DocName: this.DocName,
                DocDesc: this.DocDesc,
                ApprovalStatus: this.ApprovalStatus,
                IsUpload: this.IsUpload,
                CreateUser: this.CreateUser,
                CreateDate: this.CreateDate,
                AuditEditUser: this.AuditEditUser,
                AuditEditDate: this.AuditEditDate,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static openDocument(document) {
            services_1.SrmsServiceManager.Instance.WaterAgreementApplication.getWaterAgreementDocument(document.Id);
        }
        static uploadDocument(wa, documentType, fileName, base64File) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Uploading Document");
                if (wa.hasChanges()) {
                    store_1.StoreManager.Instance.modalStore.createInfoModal("You have unsaved changes. Please save your work before uploading a document", null);
                }
                else {
                    services_1.SrmsServiceManager.Instance.WaterAgreementApplication.uploadWaterAgreementDocument(wa.Id, documentType, fileName, base64File).then(d => {
                        let x = new WaDoc(d, wa);
                        wa.WaDoc.push(x);
                        resolve(x);
                    });
                }
            });
        }
        static createDocument(wa, documentType) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Creating Document");
                services_1.SrmsServiceManager.Instance.WaterAgreementApplication.generateWaterAgreementReport(wa.toJson(), documentType).then(d => {
                    let x = new WaDoc(d, wa);
                    wa.WaDoc.push(x);
                    resolve(x);
                });
            });
        }
    }
    exports.WaDoc = WaDoc;
    Object.defineProperty(WaDoc, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "WaDoc"
    });
    Object.defineProperty(WaDoc, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Permit Documents"
    });
    Object.defineProperty(WaDoc, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "WaId", "DocType", "DocName", "DocDesc", "ApprovalStatus", "IsUpload", "CreateUser", "CreateDate", "AuditEditUser", "AuditEditDate"]
    });
    Object.defineProperty(WaDoc, "WaIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaDoc, "DocTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaDoc, "DocTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaDoc, "DocNameLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(WaDoc, "DocNameReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaDoc, "DocDescLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(WaDoc, "DocDescTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Enter a description for the document"
    });
    Object.defineProperty(WaDoc, "DocDescReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaDoc, "ApprovalStatusLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2
    });
    Object.defineProperty(WaDoc, "ApprovalStatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaDoc, "ApprovalStatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaDoc, "IsUploadReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaDoc, "CreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(WaDoc, "CreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaDoc, "CreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(WaDoc, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(WaDoc, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(WaDoc, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "WaId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "WaIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "DocType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "DocTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "DocName", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "DocNameError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "DocDesc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "DocDescError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "ApprovalStatus", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "ApprovalStatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "IsUpload", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "IsUploadError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "CreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "CreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "CreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "CreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], WaDoc.prototype, "Wa", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], WaDoc.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaDoc.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], WaDoc.prototype, "merge", null);
});
